module.exports = __webpack_public_path__ + "img/4.0cab00dd.webp";